import { Routes, Route } from "react-router-dom";

import { DataProvider } from 'providers/data';

import theme from './components/theme/base/theme';
import { ThemeProvider } from '@mui/material/styles';

import Home from "pages/Home";
import Login from "pages/Login";
import FirstAccess from "pages/FirstAccess";
import ForgotLogin from "pages/ForgotLogin";
import ForgotPassword from "pages/ForgotPassword";
import Charges from "pages/Charges";
import Pending from "pages/Charges/Pending";
import RegisterValidation from "pages/RegisterValidation";

import ServiceFaq from "pages/ServiceFaq";
import Solicitation from "pages/Solicitation";

import Scheduling from "pages/Scheduling";
import Rescheduling from "pages/Scheduling/Rescheduling";
import SchedulingPending from "pages/Scheduling/SchedulingPending";

import Invoices from "pages/Invoices";
import PayInvoice from "pages/Invoices/PayInvoice";
import ChangePayment from "pages/Invoices/ChangePayment/index";
import TermsOfUse from "pages/Invoices/ChangePayment/TermsOfUse";

import ExchangeCenter from "pages/ExchangeCenter";
import ExchangesInProgress from "pages/ExchangeCenter/ExchangesInProgress";
import ChangeOfOwnership from "pages/ExchangeCenter/ChangeOfOwnership";
import DiscoverOtherPlans from "pages/ExchangeCenter/DiscoverOtherPlans";
import ExchangeVehicle from "pages/ExchangeCenter/ExchangeVehicle";
import Perfil from "pages/ExchangeCenter/quotation/Perfil";
import Vehicle from "pages/ExchangeCenter/quotation/Vehicle";
import Plans from "pages/ExchangeCenter/quotation/Plans";
import AdditionalServicesQuotation from "pages/ExchangeCenter/quotation/AdditionalServices";
import Payments from "pages/ExchangeCenter/quotation/Payments";
import SchedulingQuotation from "pages/ExchangeCenter/quotation/Scheduling";
import OrderSummary from "pages/ExchangeCenter/quotation/OrderSummary";

import MyVehicles from "pages/MyVehicles";
import Partner from "pages/MyVehicles/Partner";
import CoveragePlane from "pages/MyVehicles/CoveragePlane";
import InsuranceContact from "pages/MyVehicles/InsuranceContact";
import AdditionalServices from "pages/MyVehicles/AdditionalServices";

import CustomerData from "pages/CustomerData";

import AdditionalServicesLP from "pages/AdditionalServices";
import ServicesList from "pages/AdditionalServices/ServicesList";
import Payment from "pages/AdditionalServices/Payment";
import OrderSummaryAddService from "pages/AdditionalServices/OrderSummary";
import AddServicesInProgress from "pages/AdditionalServices/AddServicesInProgress";

import Page404 from "pages/404";
import LivechatLoader from "components/LivechatLoader";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <DataProvider>
        <LivechatLoader />
        <Routes>
          <Route path="/" element={<Login />} />
          {/* remover */}
          <Route path="/login" element={<Login />} />
          <Route path="login/initial" element={<Login />} />

          <Route path="esqueci-login" element={<ForgotLogin />} />
          <Route path="esqueci-senha" element={<ForgotPassword />} />
          <Route path="primeiro-acesso" element={<FirstAccess />} />
          <Route path="home" element={<Home />} />
          <Route path="cobrancas" element={<Charges isWebView={false} />} />
          <Route path="cobrancas/pendentes" element={<Pending />} />

          <Route path="checkin" element={<RegisterValidation />} />

          <Route path="wb/cobrancas" element={<Charges isWebView={true} />} />
          <Route path="wb/cobrancas/pendentes" element={<Pending />} />

          <Route path="solicitacoes" element={<Solicitation />} />
          <Route path="atendimento" element={<ServiceFaq />} />
          <Route path="agendamentos" element={<Scheduling isWebView={false} />} />
          <Route path="agendamentos/reagendamento" element={<Rescheduling isWebView={false} />} />
          <Route path="agendamentos/pendente" element={<SchedulingPending isWebView={false} />} />
          {/* webview */}
          <Route path="wb/agendamentos" element={<Scheduling isWebView={true} />} />
          <Route path="wb/agendamentos/reagendamento" element={<Rescheduling isWebView={true} />} />
          <Route path="wb/agendamentos/pendente" element={<SchedulingPending isWebView={true} />} />

          <Route path="faturas" element={<Invoices />} />
          <Route path="faturas/pagamento" element={<PayInvoice />} />
          <Route path="faturas/alterar-pagamento" element={<ChangePayment />} />
          <Route path="faturas/alterar-pagamento/termos-de-uso" element={<TermsOfUse />} />

          <Route path="meus-veiculos" element={<MyVehicles />} />
          <Route path="meus-veiculos/servicos-adicionais" element={<AdditionalServices />} />
          <Route path="meus-veiculos/parceiro" element={<Partner />} />
          <Route path="meus-veiculos/contato-da-seguradora" element={<InsuranceContact />} />
          <Route path="meus-veiculos/cobertura-do-plano" element={<CoveragePlane />} />

          <Route path="meus-dados" element={<CustomerData />} />

          <Route path="central-de-trocas" element={<ExchangeCenter isWebView={false} />} />
          <Route path="central-de-trocas/trocas-em-andamento" element={<ExchangesInProgress isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-titularidade" element={<ChangeOfOwnership isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-servico" element={<DiscoverOtherPlans isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-veiculo" element={<ExchangeVehicle isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-veiculo/perfil" element={<Perfil isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-veiculo/veiculo" element={<Vehicle isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-veiculo/planos" element={<Plans isWebView={false} />} />

          <Route path="central-de-trocas/troca-de-servico/perfil" element={<Perfil isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-servico/veiculo" element={<Vehicle isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-servico/planos" element={<Plans isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-servico/servicos-adicionais" element={<AdditionalServicesQuotation isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-servico/pagamento" element={<Payments isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-servico/agendamento" element={<SchedulingQuotation isWebView={false} />} />
          <Route path="central-de-trocas/troca-de-servico/resumo-pedido" element={<OrderSummary isWebView={false} />} />
          {/* webview */}
          <Route path="wb/central-de-trocas" element={<ExchangeCenter isWebView={true} />} />
          <Route path="wb/central-de-trocas/trocas-em-andamento" element={<ExchangesInProgress isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-titularidade" element={<ChangeOfOwnership isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-servico" element={<DiscoverOtherPlans isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-veiculo" element={<ExchangeVehicle isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-veiculo/perfil" element={<Perfil isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-veiculo/veiculo" element={<Vehicle isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-veiculo/planos" element={<Plans isWebView={true} />} />

          <Route path="wb/central-de-trocas/troca-de-servico/perfil" element={<Perfil isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-servico/veiculo" element={<Vehicle isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-servico/planos" element={<Plans isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-servico/servicos-adicionais" element={<AdditionalServicesQuotation isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-servico/pagamento" element={<Payments isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-servico/agendamento" element={<SchedulingQuotation isWebView={true} />} />
          <Route path="wb/central-de-trocas/troca-de-servico/resumo-pedido" element={<OrderSummary isWebView={true} />} />

          <Route path="servicos-adicionais" element={<AdditionalServicesLP isWebView={false} />} />
          <Route path="servicos-adicionais/servicos" element={<ServicesList isWebView={false} />} />
          <Route path="servicos-adicionais/pagamento" element={<Payment isWebView={false} />} />
          <Route path="servicos-adicionais/resumo-pedido" element={<OrderSummaryAddService isWebView={false} />} />
          <Route path="servicos-adicionais/contratacao-em-andamento" element={<AddServicesInProgress isWebView={false} />} />

          <Route path="wb/servicos-adicionais" element={<AdditionalServicesLP isWebView={true} />} />
          <Route path="wb/servicos-adicionais/servicos" element={<ServicesList isWebView={true} />} />
          <Route path="wb/servicos-adicionais/pagamento" element={<Payment isWebView={true} />} />
          <Route path="wb/servicos-adicionais/resumo-pedido" element={<OrderSummaryAddService isWebView={true} />} />
          <Route path="wb/servicos-adicionais/contratacao-em-andamento" element={<AddServicesInProgress isWebView={true} />} />

          {/* <Route path="contact" element={<Contact />} /> */}
          <Route path="*" element={<Page404 />} />
        </Routes>
      </DataProvider>
    </ThemeProvider>
  )
}

export default App;